<!-- left vertical navigation bar -->
<div class="left-bar">
  <div class="left-bar-text-container">
    <a href="/resultados#final-result"><h2 class="top-title">Resultado Total</h2></a>
    <a href="/resultados#diesel-tco"><h2>TCO Diesel</h2></a>
    <a href="/resultados#electric-tco"><h2>TCO Eléctrico</h2></a>
    <a href="/resultados#hydrogen-tco"><h2>TCO Hidrógeno</h2></a>
  </div>
</div>

<div class="content-container">
  <app-progress-bar></app-progress-bar>
  <div class="grid-container">
    <h2 id="final-result">Resultado Total</h2>
    <div class="tco-container">
      <canvas id="tco-comparison-chart"></canvas>
    </div>
    <ul class="tco-results-list">
      <li>
        <h2 class="subtitle">TCO Diesel</h2>
        <p class="price-tag">{{truckFormService.dieselTCO?.getTCO()}}</p>
      </li>
      <li>
        <h2 class="subtitle">TCO Eléctrico</h2>
        <p class="price-tag">{{truckFormService.electricTCO?.getTCO()}}</p>
      </li>
      <li>
        <h2 class="subtitle">TCO Hidrógeno</h2>
        <p class="price-tag">{{truckFormService.hydrogenTCO?.getTCO()}}</p>
      </li>
    </ul>
  </div>
  <app-tco-results *ngIf="truckFormService.dieselTCO !== null" [chartId]="'diesel-tco'"
                   [tco]="this.truckFormService.dieselTCO" [tcoTitle]="'TCO Diesel'"></app-tco-results>
  <app-tco-results *ngIf="truckFormService.electricTCO !== null" [chartId]="'electric-tco'"
                   [tco]="this.truckFormService.electricTCO" [tcoTitle]="'TCO Eléctrico'"></app-tco-results>
  <app-tco-results *ngIf="truckFormService.hydrogenTCO !== null" [chartId]="'hydrogen-tco'"
                   [tco]="this.truckFormService.hydrogenTCO" [tcoTitle]="'TCO Hidrógeno'"></app-tco-results>
  <!--  <div class="grid-container">-->
  <!--    <h2 id="final-result">Resultado Total</h2>-->
  <!--    <div class="tco-container">-->
  <!--      <canvas id="tco-comparison-chart"></canvas>-->
  <!--    </div>-->
  <!--    <div class="box-container">-->
  <!--      <ul class="tco-results-list">-->
  <!--        <li>-->
  <!--          <h3>TCO Diesel</h3>-->
  <!--          <p>{{this.truckFormService.dieselTCO?.getTCO()}}</p>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          <h3>TCO Eléctrico</h3>-->
  <!--          <p>{{this.truckFormService.electricTCO?.getTCO()}}</p>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          <h3>TCO Hidrógeno</h3>-->
  <!--          <p>{{this.truckFormService.hydrogenTCO?.getTCO()}}</p>-->
  <!--        </li>-->
  <!--      </ul>-->
  <!--    </div>-->

  <!--    <h2 id="diesel-tco">TCO Diesel</h2>-->
  <!--    <div class="pie-chart">-->
  <!--      <canvas id="diesel-tco-chart"></canvas>-->
  <!--    </div>-->
  <!--    <div class="box-container">-->
  <!--      <table class="table">-->
  <!--        <tr>-->
  <!--          <th>Campo</th>-->
  <!--          <th>Precio</th>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Precio Vehículo</td>-->
  <!--          <td class="price-tag">{{this.truckFormService.electricTCO?.vehiclePrice}}</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Combustible</td>-->
  <!--          <td class="price-tag">120000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Mantenimiento</td>-->
  <!--          <td class="price-tag">70000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Valor Residual</td>-->
  <!--          <td class="price-tag">-22000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Seguro</td>-->
  <!--          <td class="price-tag">14820</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Patente</td>-->
  <!--          <td class="price-tag">17965</td>-->
  <!--        </tr>-->
  <!--        <tr class="final-table-entry">-->
  <!--          <td>Total</td>-->
  <!--          <td>280785</td>-->
  <!--        </tr>-->
  <!--      </table>-->
  <!--    </div>-->

  <!--    <h2 id="electric-tco">TCO Eléctrico</h2>-->
  <!--    <div class="pie-chart">-->
  <!--      <canvas id="electric-tco-chart"></canvas>-->
  <!--    </div>-->
  <!--    <div class="box-container">-->
  <!--      <table class="table">-->
  <!--        <tr>-->
  <!--          <th>Campo</th>-->
  <!--          <th>Precio</th>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Precio Vehículo</td>-->
  <!--          <td class="price-tag">80000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Combustible</td>-->
  <!--          <td class="price-tag">120000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Mantenimiento</td>-->
  <!--          <td class="price-tag">70000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Valor Residual</td>-->
  <!--          <td class="price-tag">-22000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Seguro</td>-->
  <!--          <td class="price-tag">14820</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Patente</td>-->
  <!--          <td class="price-tag">17965</td>-->
  <!--        </tr>-->
  <!--        <tr class="final-table-entry">-->
  <!--          <td>Total</td>-->
  <!--          <td>280785</td>-->
  <!--        </tr>-->
  <!--      </table>-->
  <!--    </div>-->

  <!--    <h2 id="hydrogen-tco">TCO Hidrógeno</h2>-->
  <!--    <div class="pie-chart">-->
  <!--      <canvas id="hydrogen-tco-chart"></canvas>-->
  <!--    </div>-->
  <!--    <div class="box-container">-->
  <!--      <table class="table">-->
  <!--        <tr>-->
  <!--          <th>Campo</th>-->
  <!--          <th>Precio</th>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Precio Vehículo</td>-->
  <!--          <td class="price-tag">80000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Combustible</td>-->
  <!--          <td class="price-tag">120000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Mantenimiento</td>-->
  <!--          <td class="price-tag">70000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Valor Residual</td>-->
  <!--          <td class="price-tag">-22000</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Seguro</td>-->
  <!--          <td class="price-tag">14820</td>-->
  <!--        </tr>-->
  <!--        <tr>-->
  <!--          <td>Patente</td>-->
  <!--          <td class="price-tag">17965</td>-->
  <!--        </tr>-->
  <!--        <tr class="final-table-entry">-->
  <!--          <td>Total</td>-->
  <!--          <td>280785</td>-->
  <!--        </tr>-->
  <!--      </table>-->
  <!--    </div>-->
  <!--  </div>-->
  <!--  <app-tco></app-tco>-->
</div>
